// extracted by mini-css-extract-plugin
module.exports = {"fontEnterFade":"FontFade_fontEnterFade__Alkd4"};